import Progress from './types/Progress'
import ProgressBar from './component'

export const createProgress = props => new Progress(props)

export const createProgressList = propsList =>
  propsList.map(props => createProgress(props))

export default ProgressBar
